import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    profile: { name: '', account_type: 'single', org_details: '', gst_number: '' },
    license: null,
    status: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Fetching Data
    fetchDashboardRequest: (state) => { state.loading = true; },
    fetchDashboardSuccess: (state, action) => {
      state.loading = false;
      state.profile = action.payload.profile || state.profile;
      state.license = action.payload.license;
      state.status = action.payload.status;
    },
    fetchDashboardFailure: (state, action) => { state.loading = false; state.error = action.payload; },

    // CRUD Actions (Saga Triggers)
    updateProfileRequest: (state) => { state.loading = true; },
    deleteProfileRequest: (state) => { state.loading = true; },
    addEmployeeRequest: (state) => { state.loading = true; },
    editEmployeeRequest: (state) => { state.loading = true; },
    removeEmployeeRequest: (state) => { state.loading = true; },
  }
});

export const { 
    fetchDashboardRequest, fetchDashboardSuccess, fetchDashboardFailure,
    updateProfileRequest, deleteProfileRequest, addEmployeeRequest, editEmployeeRequest, removeEmployeeRequest 
} = userSlice.actions;
export default userSlice.reducer;